import { memo, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useForm, Controller } from "react-hook-form";
import DateRange2 from "../DateRange/DateRange2";
import SelectBox1 from "../SelectBox1";

const ReportPopup = ({
  filterPopup,
  searchValue,
  deleteParams,
  statusOptions,
  regionReport,
  regionManagerList,
  regionOptions,
  selected,
  setSelected,
  regionManager,
  setStatusVal,
  statusVal,
  //
  serviceEng,
  selectedService,
  setSeletedService,
  //
  overallTic,
  selectedTic,
  setSelectedTic,
  //
  overallCust,
  selectedCust,
  setSelectedCust,
  //
  overallfault,
  selectedFault,
  setSelectedFault,
  //
  overallTech,
  selectedTech,
  setSelectedTech,
  //
  overallInv,
  selectedInv,
  setSelectedInv,
  //
  overallPrinter,
  selectedPrinter,
  setSelectedPrinter,
  //
  fromDates,
  setFromDates,
  toDates,
  setToDates,
}) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#1A77BC",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      category: "",
      regionalManager: "",
      status: "",
      mobile: "",
      role: "Inventory",
      password: "",
      confirmPassword: "",
    },
  });

  console.log("filterpopup", filterPopup);
  // console.log("regionManager", regionManager);
  console.log(statusVal, "statusVal");

  console.log("fromDates", fromDates);

  let regionData = regionOptions?.find(
    (i) => i.value == selectedTic?.region_id,
  );

  let custRegionData = regionOptions?.find(
    (i) => i.value == selectedCust?.region_id,
  );

  setValue("regionalManager", regionManager?.name);
  setValue("employeeName", selectedService?.code);
  setValue("customername", selectedCust?.name);
  setValue("regionData", regionData?.label);
  setValue("regionCustData", custRegionData?.label);

  console.group("----->ReportPopup");
  console.log("selected", selected);
  console.log("selectedService", selectedService);
  console.log("selectedTic", selectedTic);
  console.log("regionList", regionOptions);
  console.log("regionData", regionData);
  console.log("overallCust", overallCust);
  console.log("custRegionData", custRegionData);
  console.log("selectedCust", selectedCust);
  console.groupEnd("<-------->");

  return (
    <div className="img-popup-design">
      <div className="img-popup">
        <div className="d-flex ac-jb">
          <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 my-1 text-center">
            {filterPopup == 1
              ? "Region"
              : filterPopup == 2
                ? "Service Engineer"
                : filterPopup == 3
                  ? "Ticket Status Report"
                  : filterPopup == 4
                    ? "Customer"
                    : filterPopup == 5
                      ? "Inventory"
                      : filterPopup == 6
                        ? "Status"
                        : filterPopup == 7
                          ? "Fault Type"
                          : filterPopup == 8
                            ? "Technical"
                            : ""}
          </p>
          <p
            className="popup-close-btn"
            onClick={() => {
              deleteParams();
            }}
          >
            {" "}
            <CloseIcon />
          </p>
        </div>
        {filterPopup == 1 && (
          <div className="text-start">
            <Controller
              control={control}
              name="category"
              rules={{ required: "Category is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Category (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={regionOptions}
                    placeholder="Select Category"
                    styles={customStyles}
                    selected={selected}
                    setSelected={(val) => {
                      field.onChange(val);
                      regionManagerList(val);
                    }}
                  />
                  {errors.category && (
                    <p className="text-danger mt-1">
                      {errors.category.message}
                    </p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="regionalManager"
              rules={{ required: "Regional Manager is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Regional Manager
                  </label>
                  <input
                    className="input-box"
                    onChange={(e) => field.onChange(e.target.value)}
                    {...field}
                    placeholder="Regional Manager"
                    styles={customStyles}
                    readOnly
                  />
                  {errors.regional && (
                    <p className="text-danger mt-1">
                      {errors.regional.message}
                    </p>
                  )}
                </div>
              )}
            />
            <div className="d-flex ac-js gap-4 col-md-12">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>
            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder="Select Status"
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        {filterPopup == 2 && (
          <div className="text-start">
            <Controller
              control={control}
              name="category"
              rules={{ required: "Engineer Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Region (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={regionOptions}
                    placeholder="Select Region"
                    styles={customStyles}
                    selected={selected}
                    setSelected={(val) => {
                      field.onChange(val);
                      regionManagerList(val);
                    }}
                  />
                  {errors.category && (
                    <p className="text-danger mt-1">
                      {errors.category.message}
                    </p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="regionalManager"
              rules={{ required: "Regional Manager is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Regional Manager
                  </label>
                  <input
                    className="input-box"
                    onChange={(e) => field.onChange(e.target.value)}
                    {...field}
                    placeholder="Regional Manager"
                    styles={customStyles}
                    readOnly
                  />
                  {errors.regional && (
                    <p className="text-danger mt-1">
                      {errors.regional.message}
                    </p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="engineerList"
              rules={{ required: "Engineer Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Engineer Name/Code (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={serviceEng}
                    placeholder="Select Engineer Name"
                    styles={customStyles}
                    selected={selectedService}
                    isDisabled={!selected?.value}
                    setSelected={(val) => {
                      field.onChange(val);
                      setSeletedService(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
            {/* <Controller
              control={control}
              name="employeeName"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Employee Code (Optional)
                  </label>
                  <input
                    className="input-box"
                    onChange={(e) => field.onChange(e.target.value)}
                    {...field}
                    placeholder="Select Regional Manager"
                    styles={customStyles}
                    readOnly
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            /> */}

            <div className="d-flex ac-js gap-4 col-md-12">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>

            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder={"Select Status"}
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        {filterPopup == 3 && (
          <div className="text-start">
            <Controller
              control={control}
              name="ticketId"
              rules={{ required: "Engineer Name is required" }}
              render={({ field }) => (
                <div
                  style={{
                    border: "1px solid #1A77BC",
                    borderRadius: "10px",
                    padding: "5px",
                  }}
                  className="mt-2"
                >
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Ticket ID (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={overallTic}
                    placeholder="Select Overall ticket"
                    styles={customStyles}
                    selected={selectedTic}
                    setSelected={(val) => {
                      field.onChange(val);
                      setSelectedTic(val);
                      // if (val?.region_id) {
                      //   // Create a region object from the region_id
                      //   setSelected({
                      //     value: val.region_id,
                      //     label:
                      //       regionOptions.find((r) => r.value === val.region_id)
                      //         ?.label || `Region ${val.region_id}`,
                      //   });
                      // } else {
                      //   setSelected(null);
                      // }
                    }}
                  />
                  {/* <div className="mt-3">
                    <SelectBox1
                      {...field}
                      options={regionOptions}
                      placeholder="Select Ticket ID"
                      styles={customStyles}
                    />
                  </div>
                  {errors.category && (
                    <p className="text-danger mt-1">
                      {errors.category.message}
                    </p>
                  )} */}
                </div>
              )}
            />

            <div className="d-flex ac-js gap-4 col-md-12">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>
            <div className="mt-1">
              <Controller
                control={control}
                name="category"
                rules={{ required: "Engineer Name is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                      Region (Optional)
                    </label>
                    <SelectBox1
                      {...field}
                      options={regionOptions}
                      placeholder="Select Region"
                      styles={customStyles}
                      selected={selected}
                      setSelected={(val) => {
                        field.onChange(val);
                        setSelected(val);
                      }}
                    />
                    {errors.category && (
                      <p className="text-danger mt-1">
                        {errors.category.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder={"Select Status"}
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        {filterPopup == 4 && (
          <div className="text-start">
            <Controller
              control={control}
              name="customerId"
              rules={{ required: "Engineer Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Customer Name/ID (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={overallCust}
                    placeholder="Select Customer ID "
                    styles={customStyles}
                    selected={selectedCust}
                    setSelected={(val) => {
                      field.onChange(val);
                      setSelectedCust(val);
                      // if (val?.region_id) {
                      //   // Create a region object from the region_id
                      //   setSelected({
                      //     value: val.region_id,
                      //     label:
                      //       regionOptions.find((r) => r.value === val.region_id)
                      //         ?.label || `Region ${val.region_id}`,
                      //   });
                      // } else {
                      //   setSelected(null);
                      // }
                    }}
                  />
                  {errors.category && (
                    <p className="text-danger mt-1">
                      {errors.category.message}
                    </p>
                  )}
                </div>
              )}
            />
            {/* <Controller
              control={control}
              name="customername"
              rules={{ required: "Engineer Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">Customer Name</label>
                  <input
                    className="input-box"
                    onChange={(e) => field.onChange(e.target.value)}
                    {...field}
                    placeholder="Select Customer Name"
                    styles={customStyles}
                    readOnly
                  />
                  {errors.category && (
                    <p className="text-danger mt-1">
                      {errors.category.message}
                    </p>
                  )}
                </div>
              )}
            /> */}
            {/* <p className="f2 fs-sm-13 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 my-3 ">
              Closed Tickets
            </p> */}
            <div className="d-flex ac-js gap-4 col-md-12">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>
            <div className="mt-2">
              <Controller
                control={control}
                name="category"
                rules={{ required: "Engineer Name is required" }}
                render={({ field }) => (
                  <div>
                    <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                      Region (Optional)
                    </label>
                    <SelectBox1
                      {...field}
                      options={regionOptions}
                      placeholder="Select Region"
                      styles={customStyles}
                      selected={selected}
                      setSelected={(val) => {
                        field.onChange(val);
                        setSelected(val);
                      }}
                    />
                    {errors.category && (
                      <p className="text-danger mt-1">
                        {errors.category.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder={"Select Status"}
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        {filterPopup == 5 && (
          <div className="text-start">
            <Controller
              control={control}
              name="empId"
              rules={{ required: "Engineer Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    {" "}
                    Select Inventory
                  </label>
                  <SelectBox1
                    {...field}
                    options={overallInv}
                    placeholder="Select Employee ID"
                    styles={customStyles}
                    selected={selectedInv}
                    setSelected={(val) => {
                      field.onChange(val);
                      setSelectedInv(val);
                    }}
                  />
                  {errors.category && (
                    <p className="text-danger mt-1">
                      {errors.category.message}
                    </p>
                  )}
                </div>
              )}
            />

            <div className="d-flex ac-js gap-4 col-md-12 ">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>
            <Controller
              control={control}
              name="region"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Region (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={regionOptions}
                    placeholder="Select Region"
                    styles={customStyles}
                    selected={selected}
                    setSelected={(val) => {
                      field.onChange(val);
                      regionManagerList(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="regionalManager"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Regional Manager
                  </label>
                  <input
                    className="input-box"
                    onChange={(e) => field.onChange(e.target.value)}
                    {...field}
                    placeholder="Regional Manager"
                    styles={customStyles}
                    readOnly
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder={"Select Status"}
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        {filterPopup == 6 && (
          <div className="text-start">
            <Controller
              control={control}
              name="category"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Selected Region (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={regionOptions}
                    placeholder={"Select Region"}
                    styles={customStyles}
                    selected={selected}
                    setSelected={(val) => {
                      field.onChange(val);
                      setSelected(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />

            <div className="d-flex ac-js gap-4 col-md-12 ">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>

            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Ticket Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder={"Select Status"}
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        {filterPopup == 7 && (
          <div className="text-start">
            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Fault Type
                  </label>
                  <SelectBox1
                    {...field}
                    options={overallfault}
                    placeholder={"Select Fault Type"}
                    styles={customStyles}
                    selected={selectedFault}
                    setSelected={(val) => {
                      field.onChange(val);
                      setSelectedFault(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />

            <div>
              <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                Printer sr.no
              </label>
              <SelectBox1
                options={overallPrinter}
                placeholder={"Select Printer"}
                styles={customStyles}
                selected={selectedPrinter}
                setSelected={(val) => {
                  setSelectedPrinter(val);
                }}
              />
            </div>

            <div className="d-flex ac-js gap-4 col-md-12 ">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>

            <Controller
              control={control}
              name="status"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder={"Select Status"}
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        {filterPopup == 8 && (
          <div className="text-start">
            <Controller
              control={control}
              name="empId"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Employee ID/Name (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={overallTech}
                    placeholder="Select Employee ID"
                    styles={customStyles}
                    selected={selectedTech}
                    setSelected={(val) => {
                      field.onChange(val);
                      setSelectedTech(val);
                    }}
                  />
                  {errors.category && (
                    <p className="text-danger mt-1">
                      {errors.category.message}
                    </p>
                  )}
                </div>
              )}
            />

            <div className="d-flex ac-js gap-4 col-md-12 ">
              <DateRange2
                fromDate={fromDates}
                setFromDate={(val) => setFromDates(val)}
                toDate={toDates}
                setToDate={(val) => setToDates(val)}
              />
            </div>

            <Controller
              control={control}
              name="region"
              rules={{ required: "Region is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Region (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={regionOptions}
                    placeholder="Select Region"
                    styles={customStyles}
                    selected={selected}
                    setSelected={(val) => {
                      field.onChange(val);
                      regionManagerList(val);
                    }}
                  />
                  {errors.region && (
                    <p className="text-danger mt-1">{errors.region.message}</p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="regionalManager"
              rules={{ required: "Technical Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Regional Manager
                  </label>
                  <input
                    className="input-box"
                    onChange={(e) => field.onChange(e.target.value)}
                    {...field}
                    placeholder="Regional Manager"
                    styles={customStyles}
                    readOnly
                  />
                  {errors.technicalname && (
                    <p className="text-danger mt-1">
                      {errors.technicalname.message}
                    </p>
                  )}
                </div>
              )}
            />
            <Controller
              control={control}
              name="status"
              rules={{ required: "Status is required" }}
              render={({ field }) => (
                <div>
                  <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 text-center">
                    Status (Optional)
                  </label>
                  <SelectBox1
                    {...field}
                    options={statusOptions}
                    placeholder="Select Status"
                    styles={customStyles}
                    selected={statusVal}
                    setSelected={(val) => {
                      field.onChange(val);
                      setStatusVal(val);
                    }}
                  />
                  {errors.status && (
                    <p className="text-danger mt-1">{errors.status.message}</p>
                  )}
                </div>
              )}
            />
          </div>
        )}
        <button
          type="submit"
          onClick={() =>
            regionReport(
              searchValue,
              selected,
              fromDates,
              toDates,
              statusVal,
              selectedService,
              selectedTic,
              selectedCust,
              selectedFault,
              selectedInv,
              selectedTech,
              selectedPrinter,
            )
          }
          className="Sub_btn f1 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20 mt-3"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default memo(ReportPopup);
